/* eslint-disable react-hooks/rules-of-hooks */
import React, {FC, useMemo, useState, useEffect} from "react";
import ReactDOMServer from "react-dom/server";

import { Avatar, Badge } from "antd";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

import AppIcons from "./AppIcons.tsx";

// My functions
// import fnc from "../../libs/fnc.ts";

import type {Tuser} from "../../types/easyTypes.ts";
import type {Tapp} from "../../types/uiapp.d.ts";

type TconfirmationMethod = {
  rowkey:string,
  title_ru:string,
  title_en:string,
  title_tr:string,
  needToApprove:boolean
};

type Tstep = {
  user:string,
  status:"inline" | "waiting" | "reject" | "accept" | "message" | "question",
  confirmationMethod:string, // "notification" | "examination" | "approval" | can be more...
  strDate:string
};

// {appkey, db, id, col}
type componentProps = {
  appkey:string,
  db:string,
  iid:string,
  data?:Array<Tstep>,
  allusers?:Array<Tuser>,
  allapps?:Array<Tapp>,
  confirmationmethods?:Array<TconfirmationMethod>,
  color?:string,
  backgroundColor?:string,
  style?:React.CSSProperties | CSS.Properties,
  className?:string,
  gethtml?:boolean | "true" | "false"
} & {[key:string]:any}; // string | boolean | number | React.ReactNode

const {$, rz} = window;

const approvalRenderer:FC<componentProps> = (props) => {
  // const customStyle = (props.style ? {...props.style} : undefined);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [theme, setTheme] = useState($("html").attr("data-theme"));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [lng, setLng] = useState($("html").attr("lang"));
  const [data, setData] = useState<Array<Tstep>>([]);
  const [errMsg, setErrMsg] = useState<string>("");

  const styl = useMemo<React.CSSProperties | CSS.Properties>(() => {
    const est:React.CSSProperties | CSS.Properties = {...props.style};
    let clr:string; const allc = (props.color || "").split("|"); if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    if (!est?.color && clr) { est.color = clr }
    let bclr:string; const allb = (props.backgroundColor || "").split("|"); if (allb.length > 1) { bclr = (theme === "dark" ? allb[1] : allb[0]) } else { bclr = allb[0] }
    if (!est?.backgroundColor && bclr) { est.backgroundColor = bclr }
    return est;
  }, [props, theme]);

  // Get all users
  const [allusers, setAllUsers] = useState<Array<Tuser>>([]);
  useEffect(() => {
    if (allusers.length || errMsg) { return }
    if (props.allusers) { setAllUsers(props.allusers); return }
    rz.serverAction({appkey: props.appkey, action: "loadAuxiliaryDBs", params: {dbs: ["users"]}}).then((ans) => {
      // @ts-ignore
      if (ans && ans.users && ans.users.length) { setAllUsers(ans.users) }
      else { setErrMsg(" ") }
    });
  }, [allusers.length, errMsg, props.allusers, props.appkey]);

  // Get approval methods
  const [allConfirmationMethods, setAllConfirmationMethods] = useState<Array<TconfirmationMethod>>([]);
  useEffect(() => {
    if (allConfirmationMethods.length || errMsg) { return }
    if (props.confirmationmethods && rz.isArray(props.confirmationmethods)) { setAllConfirmationMethods(props.confirmationmethods); return }
    rz.serverAction({appkey: props.appkey, action: "loadAuxiliaryDBs", params: {dbs: ["pw_confirmation_methods"]}}).then((ans) => {
      // @ts-ignore
      if (ans && ans.pw_confirmation_methods && ans.pw_confirmation_methods.length) { setAllConfirmationMethods(ans.pw_confirmation_methods) }
      else { setErrMsg(" ") }
    });
  }, [allConfirmationMethods.length, props.confirmationmethods, errMsg, props.appkey]);

  // Load data
  useEffect(() => {
    if (props?.data && props.data.length) { setData(props.data); return }
    if (!props.db || !props.iid) { return }
    rz.serverAction({appkey: props.appkey, action: "loadAuxiliaryDBs", params: {dbs: [props.db], filters: {_id: props.iid}}}).then((ans) => {
      if (ans && ans[props.db] && ans[props.db][0] && ans[props.db][0].approval && ans[props.db][0]._id === props.iid) { setData(ans[props.db][0].approval) }
      else { setErrMsg(" ") }
    });
  }, [props.appkey, props.db, props.iid, props.data]);

  // Build array of Avatars
  const cellContent = useMemo(() => {
    if (!data || !rz.isArray(data) || !data.length) { return "" }

    return (
      <div key={"avatar-group"} className={"rz-padding-top-8"}>
        {data.map((ii:Tstep, i:number) => {
          // const confrmMethod:TconfirmationMethod = allConfirmationMethods.find((mm) => (mm.rowkey === ii.confirmationMethod)) || {rowkey: ii.confirmationMethod, title_ru: "", title_en: "", title_tr: "", needToApprove: false};
          // @ts-ignore
          const usr = (allusers.find((uu) => (uu.login.toLowerCase() === (ii.user || "").toLowerCase())) || {login: ii.user, name_ru: "", name_en: ""});

          return (
            <Badge key={"badge-" + (i + 1)} count={
              <AppIcons key={"badge-ico-" + (i + 1)} className={"rz-margin-right-8"} icopath={rz.switchCase([
                ii.status === "inline", "gr/GrDocumentLocked",
                ii.status === "waiting", "gr/GrDocumentTime",
                ii.status === "reject", "ai/AiOutlineCloseCircle",
                ii.status === "accept", "ai/AiOutlineCheckCircle",
                ii.status === "message", "fa/FaTelegramPlane",
                ii.status === "question", "ai/AiOutlineQuestionCircle",
                "md/MdErrorOutline"
              ])} attrs={{ size: "1.2em", color: rz.switchCase([
                ii.status === "inline", "Gray|Lightgrey",
                ii.status === "waiting", "Royalblue|Lightskyblue",
                ii.status === "reject", "Tomato|Salmon",
                ii.status === "accept", "Seagreen|Lightgreen",
                ii.status === "message", "Steelblue|Skyblue",
                ii.status === "question", "Sandybrown",
                "Gray|Lightgrey"
              ]), "uk-tooltip": rz.switchCase([
                ii.status === "inline", rz.strFromSelectedLng({lng: (lng as string), ru: "В очереди", en: "In line", tr: "Çizgide"}),
                ii.status === "waiting", rz.strFromSelectedLng({lng: (lng as string), ru: "На рассмотрении", en: "On consideration", tr: "Dikkate alınarak"}),
                ii.status === "reject", rz.strFromSelectedLng({lng: (lng as string), ru: "Отклонено", en: "Rejected", tr: "Reddedilmiş"}),
                ii.status === "accept", rz.strFromSelectedLng({lng: (lng as string), ru: "Согласовано", en: "Accepted", tr: "Kabul edilmiş"}),
                ii.status === "message", rz.strFromSelectedLng({lng: (lng as string), ru: "Отправлено информационное сообщение", en: "Sent an information message", tr: "Bir bilgi mesajı gönderdi"}),
                ii.status === "question", rz.strFromSelectedLng({lng: (lng as string), ru: "Вопрос в связанном чате", en: "There is a question in the related chat", tr: "İlgili sohbette bir soru var"}),
                rz.strFromSelectedLng({lng: (lng as string), ru: "Ошибка", en: "An Error", tr: "Bir hata"})
              ]) }}
              />
            } >
              <Avatar key={"avatar-" + (i + 1)} size="large" shape="circle"
                src={"/ui/avatar/" + ii.user} icon={<AppIcons icopath="fa/FaUserSecret" attrs={{}} />}
                uk-tooltip={rz.strFromSelectedLng({lng: (lng as string), ru: (usr.name_ru as string), en: (usr.name_en as string), def: (usr.login as string)})}
              />
            </Badge>
          )
        })}
      </div>
    );
  }, [data, allusers, lng]);

  // Return React.Element
  if (props?.getHTML || props?.gethtml === true || props?.gethtml === "true") {
    return ReactDOMServer.renderToStaticMarkup( // renderToString
      <div
        key={"approval-renderer-" + props.db + "-" + props.iid} id={"approval-renderer-" + props.db + "-" + props.iid}
        className={props.className} style={styl}
      >
        {cellContent}
      </div>
    );
  }

  return (
    <div
      key={"approval-renderer-" + props.db + "-" + props.iid} id={"approval-renderer-" + props.db + "-" + props.iid}
      className={props.className} style={styl}
    >
      {cellContent}
    </div>
  );
};

export default approvalRenderer;
